<template>
  <div>
  <div>
    <MenuAemps></MenuAemps>
  </div>
  <div class="crearAemps"> 
    <form v-on:submit.prevent="actualizarCartas" class="crear-cartas">

      <label for="principioActivo">Principio Activo</label>
      <input type="text" name="principioActivo" v-model="carta.principioActivo" id="principioActivo">

      <label for="nombreComercial">Nombre Comercial</label>
      <input type="text" name="nombreComercial" id="nombreComercial" v-model="carta.nombreComercial">

      <label for="fecha">Fecha</label>
      <input type="text" v-model="carta.fecha" id="fecha" required>

      <label for="asunto">Asunto</label>
      <input type="text" v-model="carta.asunto" id="asunto" required>

      <label for="pdf">PDF:</label>
      <input type="file" name="pdf" id="pdfFile" @change="handleFileChange">

      <label for="fecha_publicacion_programada">Fecha de publicación programada</label>
      <VueDatePicker v-model="carta.fecha_publicacion_programada" :format-locale="es" locale="es" placeholder="Seleccione en el calendario para programar su publicación" text-input />

      <div>
        <button type="submit" role="group" class="btn">Modificar</button>
      </div>
    </form>
  </div>  </div>
</template>




<script>
import MenuAemps from './MenuAemps.vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import { es } from 'date-fns/locale';


export default {
  
  components: {
    MenuAemps,
    VueDatePicker,

  },
  data() {
    return {
      carta: {
        principioActivo: '',
          nombreComercial: '',
          asunto: '',
          fecha:'',
          fecha_publicacion_programada:'',

          
      },
      pdfFile: null,
      timezone: es,

    };
  },
  created() {
   
    this.obtenerInformacionID();
  },


  methods: {
    obtenerInformacionID() {
      fetch('/php/lista.php?consultar=' + this.$route.params.id)
        .then(respuesta => respuesta.json())
        .then(datosRespuesta => {
         
          this.carta = datosRespuesta[0];
        })
        .catch(error => console.error('Error al obtener datos:', error));
    },

    handleFileChange(event) {
      this.pdfFile = event.target.files[0];
     
    },

    actualizarCartas() {
    
     const datosEnviar = {
    id: this.$route.params.id,
    principioActivo: this.carta.principioActivo,
    nombreComercial: this.carta.nombreComercial,
    asunto: this.carta.asunto,
    fecha: this.carta.fecha,
    fecha_publicacion_programada:this.carta.fecha_publicacion_programada,

    

  };


  const formData = new FormData();
  if (this.pdfFile !== null) {
    formData.append('pdf', this.pdfFile);
  }
  formData.append('data', JSON.stringify(datosEnviar));

  fetch(`/php/lista.php?actualizar=` + this.$route.params.id, {
    method: 'POST',
    body: formData,
 
    
  })
    .then(response => response.json())
    .then(() => {
      
      window.location.href = '../listar';
    })
    .catch(error => {
      console.error('Error al actualizar la carta:', error);
 });
  },
  },
};
</script>